import baseIsNative from "./component-library454.mjs";
import getValue from "./component-library455.mjs";
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
export {
  getNative as default
};
